import { ChangeEvent } from 'react';
import { Box, Button, Icon, Input } from '@nimbus-ds/components';
import { SlidersIcon } from '@nimbus-ds/icons';
import { SearchFilterAppliedFilters } from 'commons/components/SearchFilterAppliedFilters';
import { SearchFilterInterfaceIdLabel } from 'commons/types';
import {
  SavedSearches,
  SavedSearchesConfigButton,
} from 'domains/Orders/components/SavedSearches';
import { FiltersParamsType } from 'domains/Orders/Orders/ordersService';

interface SearchFilterMobileProps {
  placeholder: string;
  label?: string;
  ariaLabel?: string;
  resultCount?: string;
  appliedFilters: SearchFilterInterfaceIdLabel[];
  filters: FiltersParamsType;
  handleChangeSavedSearch: (newFilters: FiltersParamsType) => void;
  isLoading?: boolean;
  onClick?: () => void;
  onDismiss?: (key: string) => any;
  rightElement?: React.ReactNode;
  onSubmit: (text: string) => void;
  value: string;
  onChange: (value: string) => void;
  sortByElement?: React.ReactNode;
  onClearFilterButtonClick?: () => void;
  onSaveFilterButtonClick?: () => void;
  onSavedSearchesConfigClick: () => void;
  showSaveFiltersButton?: boolean;
}

export function SearchFilterMobile({
  placeholder,
  label: labelButton,
  ariaLabel,
  resultCount,
  appliedFilters,
  filters,
  handleChangeSavedSearch,
  rightElement,
  onSubmit,
  onDismiss,
  onClick,
  isLoading,
  value,
  onChange,
  onClearFilterButtonClick,
  onSaveFilterButtonClick,
  onSavedSearchesConfigClick,
  sortByElement,
  showSaveFiltersButton = false,
}: Readonly<SearchFilterMobileProps>) {
  const handleChange = ({
    target: { value },
  }: ChangeEvent<HTMLInputElement>) => {
    onChange(value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      event.stopPropagation();
      onSubmit(value);
    }
  };

  const renderFiltersButton = onClick && (
    <>
      <SavedSearchesConfigButton onClick={onSavedSearchesConfigClick} />
      <Button onClick={onClick}>
        <Icon source={<SlidersIcon />} />
        {labelButton}
      </Button>
    </>
  );

  const styleGridSortBy = sortByElement ? '9.5fr 0.5fr' : '';

  return (
    <Box display="flex" flexDirection="column" gap="2">
      <Box display="grid" gridTemplateColumns={styleGridSortBy} gridGap="1">
        <Box display="flex" gap="1">
          <Input.Search
            type="search"
            name="search"
            aria-label={ariaLabel}
            placeholder={placeholder}
            onKeyDown={handleKeyDown}
            value={value}
            onChange={handleChange}
            maxLength={150}
          />
          {renderFiltersButton}
        </Box>
        {!!sortByElement && <Box>{sortByElement}</Box>}
      </Box>
      <SavedSearches
        appliedFilter={filters}
        onSavedSearchClick={handleChangeSavedSearch}
        visible
      />
      {appliedFilters.length > 0 && (
        <SearchFilterAppliedFilters
          resultCount={resultCount}
          appliedFilters={appliedFilters}
          rightElement={rightElement}
          desktopWrap="wrap"
          isLoading={isLoading}
          onChange={onChange}
          onDismiss={onDismiss}
          showClearFiltersButton
          showSaveFiltersButton={showSaveFiltersButton}
          onClearFilterButtonClick={onClearFilterButtonClick}
          onSaveFilterButtonClick={onSaveFilterButtonClick}
        />
      )}
    </Box>
  );
}
